import { AxiosResponse } from "axios";
import axiosInstance from "../../../../interceptors/axiosInstance";
import { ArgumentosEstado } from "../components/models/listaModel";
import { ListResponseDto } from "../../../../dtos/ListResponseDto";
import { ListaMINVU } from "../components/modalListadoMinvu";

const BASEURL = 'siscred-api-dividendos/v1/minvu/';
const getListaMinvu = async (fechaDesde: string, fechaHasta: string, tipoArchivo: string) => {
    const response: AxiosResponse<ListResponseDto<ListaMINVU>> = await axiosInstance.get(`${BASEURL}listados-minvu`, {
        params: {
            fechaDesde: fechaDesde,
            fechaHasta: fechaHasta,
            tipoArchivo: tipoArchivo
        }
    });

    return response;
};

const actualizarEstado = async (data: ArgumentosEstado) => {
    const response: AxiosResponse = await axiosInstance.put(`${BASEURL}update-envio-minvu/${data.idEnvio}`, data);
    return response;
}

const deleteListMinvu = async (id: number, tipoArchivo: string) => {
    const response: AxiosResponse = await axiosInstance.delete(`${BASEURL}delete-envio-minvu/${id}`, {
        params: {
            idEnvio: id,
            tipoArchivo: tipoArchivo
        }
    });
    return response;
}

export {
    getListaMinvu,
    actualizarEstado,
    deleteListMinvu
}